<template>

<div>

  <Medium v-if="currentLang == 'es'" :size="size"/>

  <Twitter :size="size"/>

</div>

</template>

<script>
import Medium from './Medium.vue'
import Twitter from './Twitter.vue'

export default {
  name: 'SocialLink',
  props: {
    size: String
  },
  components: {
    Medium,
    Twitter
  },
  computed: {
    currentLang: function() {
      try {
        var locale = this.$parent.$locale
        if ((locale == undefined) || (locale == null)) {
          locale = 'en'
        }
        return locale
      }
      catch(e) {
        return 'en'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
